export default __webpack_public_path__ + "static/media/share-social-media-image.3b13b6dc.jpg";